module.exports = __webpack_public_path__ + "static/logo-vert-square-x512-164a0d9623b54624d3f65b2c794e0c7d.png";